var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textra"},[_c('div',{staticClass:"mainTextra",style:(_vm.mainStyleComputed),domProps:{"innerHTML":_vm._s(_vm.currentWord)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }